export const loadingBarOptions = {
  color: '#FAA831',
  failedColor: '#cd201f',
  thickness: '3px',
  transition: { speed: '0.5s', opacity: '0.6s', termination: 300 },
  autoRevert: true,
  location: 'top',
  inverse: false
}



// WEBPACK FOOTER //
// ./src/config/loading-bar.js